//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEFAULT_LANGUAGE_CODE } from "../../../assets/js/constants/commons";
import { LANGUAGE_CODES } from "../../../assets/js/enumerators/commons";
import { normalizeString } from "../../../assets/js/utils/commons";

export default {
  name: "S2InputTags",
  components: {
    BaseTransitionSimple: () =>
      import("../../common/transitions/BaseTransitionSimple.vue"),
    InputTagsMain: () => import("./InputTagsMain.vue"),
    InputTagsOptions: () => import("./InputTagsOptions.vue"),
    MessageError: () => import("../message/MessageError.vue"),
  },
  props: {
    disabled: Boolean,
    editable: Boolean,
    error: Boolean,
    errorMessage: {
      type: String,
      default: "",
    },
    language: {
      type: String,
      default: DEFAULT_LANGUAGE_CODE,
      validator: (language) => {
        return Object.values(LANGUAGE_CODES).includes(language);
      },
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      active: false,
      search: "",
      translations: {},
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(
        (option) =>
          !this.search ||
          normalizeString(option.label).includes(normalizeString(this.search))
      );
    },
    selectedOptions() {
      return this.options.filter((option) => this.value.includes(option.id));
    },
  },
  watch: {
    language: {
      handler() {
        this.updateTranslations();
      },
      immediate: true,
    },
  },
  methods: {
    emitNew() {
      if (!this.disabled && !!this.search) {
        this.$emit("new", this.search);
      }
    },
    emitValue(id) {
      if (!this.disabled) {
        this.$emit(
          "input",
          this.value.includes(id)
            ? this.value.filter((el) => el !== id)
            : [...this.value, id]
        );
      }
    },
    setActive(active = false) {
      this.active = active;
    },
    setSearch(search) {
      this.search = search;
    },
    updateTranslations() {
      import(`../../../lang/${this.language}.json`).then((data) => {
        this.translations = data.tags;
      });
    },
  },
};
